/** Разделяет фразу на две строки примерно поровну по длине */
export function splitPhraseIntoTwoLines(phrase: string): [string, string] {
  const words = phrase.split(' ');

  const totalLength = phrase.length;

  let currentLength = 0;
  let splitIndex = 0;

  while (splitIndex < words.length) {
    const word = words[splitIndex];

    if (currentLength + word.length + 1 <= totalLength / 2) {
      currentLength += word.length + 1;

      splitIndex++;
    } else {
      break;
    }
  }

  return [words.slice(0, splitIndex).join(' '), words.slice(splitIndex).join(' ')];
}
